import Axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { emissionKeys } from "src/query-keys";
import { APIError, Emission, EmissionType } from "src/types";

export type EmissionMutationData = Pick<Emission, "name">;

/**
 * Deserialize the json format into a Javascript object
 */
function deserialize(data: Emission): Emission {
  return {
    ...data,
  };
}

export function useEmissions(scenarioId: number | string, enabled = true) {
  async function queryFn(scenarioId: number | string): Promise<Emission[]> {
    const result = await Axios.get(`/planning-api/scenarios/${scenarioId}/emissions`);
    return result.data.map(deserialize);
  }
  return useQuery<Emission[], AxiosError<APIError>>(emissionKeys.all(scenarioId), () => queryFn(scenarioId), {
    enabled: enabled,
  });
}

export function useEmission(scenarioId: number | string, emissionId: number | string, emissionType: EmissionType) {
  async function queryFn(scenarioId: number | string): Promise<Emission[]> {
    const result = await Axios.get(`/planning-api/scenarios/${scenarioId}/emissions`);
    return result.data.map(deserialize);
  }

  // TODO: can this be improved by using the `useEmissions` cache?
  //   intiialData: https://react-query.tanstack.com/guides/initial-query-data#initial-data-from-cache
  return useQuery<Emission[], AxiosError<APIError>, Emission | undefined>(
    emissionKeys.detail(scenarioId, emissionId),
    () => queryFn(scenarioId),
    {
      select: (emissions) => {
        return emissions.find(
          (emission) => emission.id.toString() === emissionId.toString() && emission.type === emissionType
        );
      },
    }
  );
}
